import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import { i18n } from '../../translate/i18n';

export const fetchStatusVerificationItemsSuccess = (statusVerificationItems) => {
  return {
    type: actionTypes.FETCH_STATUS_VERIFICATION_ITEMS_SUCCESS,
    statusVerificationItems: statusVerificationItems
  };
};

export const requestStatusVerificationItemsFail = (error) => {
  return {
    type: actionTypes.REQUEST_STATUS_VERIFICATION_ITEMS_FAIL,
    error: error
  };
};

export const requestStatusVerificationItemsStart = () => {
  return {
    type: actionTypes.REQUEST_STATUS_VERIFICATION_ITEMS_START
  };
};

export const deleteStatusVerificationItemsSuccess = (statusVerificationItem) => {
  return {
    type: actionTypes.DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS,
    statusVerificationItem: statusVerificationItem
  }
}

export const checkDeleteStatusVerificationItemsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_STATUS_VERIFICATION_ITEMS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateStatusVerificationItemsSuccess = (statusVerificationItem) => {
  return {
    type: actionTypes.UPDATE_STATUS_VERIFICATION_ITEMS_SUCCESS,
    statusVerificationItem: statusVerificationItem
  }
}

export const postStatusVerificationItemsSuccess = (statusVerificationItem) => {
  return {
    type: actionTypes.POST_STATUS_VERIFICATION_ITEMS_SUCCESS,
    statusVerificationItem: statusVerificationItem
  }
}

export const fetchStatusVerificationItems = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestStatusVerificationItemsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/statusverificationitems' + queryParams)
      .then(res => {
        dispatch(fetchStatusVerificationItemsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestStatusVerificationItemsFail(err));
      });
  };
};

export const deleteStatusVerificationItems = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestStatusVerificationItemsStart());
      API.put('/statusverificationitems/' + index + '/delete')
        .then(res => {
          dispatch(deleteStatusVerificationItemsSuccess(res.data));
          toastr.success(i18n.t('deleteStatusVerificationItems.toastr'), `${res.data.name}${i18n.t('deleteStatusVerificationItems.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestStatusVerificationItemsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteStatusVerificationItems = (index) => {
  return dispatch => {
    dispatch(requestStatusVerificationItemsStart());
    API.get('/statusverificationitems/' + index + '/checkdelete')
      .then(res => {
        dispatch(checkDeleteStatusVerificationItemsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestStatusVerificationItemsFail(err));
      });
  }
}

export const postStatusVerificationItems = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestStatusVerificationItemsStart());
      API.post('/statusverificationitems', body)
        .then(res => {
          dispatch(postStatusVerificationItemsSuccess(res.data));
          toastr.success(i18n.t('postStatusVerificationItems.toastr'), `${res.data.name}${i18n.t('postStatusVerificationItems.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestStatusVerificationItemsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postStatusVerificationItems.toastrError'), i18n.t('postStatusVerificationItems.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateStatusVerificationItems = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestStatusVerificationItemsStart());
      API.put('/statusverificationitems/' + index, body)
        .then(res => {
          dispatch(updateStatusVerificationItemsSuccess(res.data));
          toastr.success(i18n.t('updateStatusVerificationItems.toastr'), `${res.data.name}${i18n.t('updateStatusVerificationItems.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestStatusVerificationItemsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateStatusVerificationItems.toastrError'), i18n.t('updateStatusVerificationItems.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
